import React from 'react';
import Header from '../components/Header';
import Results from '../components/Results';
import Footer from '../components/Footer';

const ResultsPage = () => {
  return (
    <div className="App">
      <Header />
      <main><Results /></main>
      <Footer />
    </div>
  );
};

export default ResultsPage;
